import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-golf-50 to-fairway-100 dark:from-gray-900 dark:via-emerald-950 dark:to-golf-950">
      <div className="container mx-auto px-4 py-8">
        <header className="text-center mb-12">
          <img src="/golf-pin.svg" alt="" className="mx-auto mb-4 h-24 w-24 drop-shadow-xl" />
          <h1 className="text-4xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-golf-700 to-emerald-600 dark:from-golf-400 dark:to-emerald-300 mb-4">
            🏌️ Golf App
          </h1>
          <p className="text-xl text-golf-700 dark:text-golf-300">
            Track your rounds, improve your game
          </p>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <Link to="/dashboard" className="group">
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-blue-500 hover:bg-gray-50 dark:hover:bg-gray-700/50">
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 dark:bg-blue-900 p-3 rounded-lg">
                  <span className="text-2xl">📊</span>
                </div>
                <h3 className="text-xl font-semibold ml-4 text-gray-800 dark:text-gray-200">Dashboard</h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400">
                View your stats, recent rounds, and handicap progress
              </p>
            </div>
          </Link>

          <Link to="/courses" className="group">
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 hover:scale-105 border-l-4 border-golf-500 hover:bg-gray-50 dark:hover:bg-gray-700/50">
              <div className="flex items-center mb-4">
                <div className="bg-gradient-to-br from-golf-100 to-emerald-100 dark:from-golf-900 dark:to-emerald-900 p-3 rounded-lg">
                  <span className="text-2xl">🏌️</span>
                </div>
                <h3 className="text-xl font-semibold ml-4 text-gray-800 dark:text-gray-200">Courses</h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400">
                Browse golf courses, add new courses, and view course details
              </p>
            </div>
          </Link>

          <Link to="/rounds" className="group">
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-orange-500 hover:bg-gray-50 dark:hover:bg-gray-700/50">
              <div className="flex items-center mb-4">
                <div className="bg-orange-100 dark:bg-orange-900 p-3 rounded-lg">
                  <span className="text-2xl">📝</span>
                </div>
                <h3 className="text-xl font-semibold ml-4 text-gray-800 dark:text-gray-200">Rounds</h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400">
                Record new rounds, track scores, and view round history
              </p>
            </div>
          </Link>

          <Link to="/stats" className="group">
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-purple-500 hover:bg-gray-50 dark:hover:bg-gray-700/50">
              <div className="flex items-center mb-4">
                <div className="bg-purple-100 dark:bg-purple-900 p-3 rounded-lg">
                  <span className="text-2xl">📈</span>
                </div>
                <h3 className="text-xl font-semibold ml-4 text-gray-800 dark:text-gray-200">Statistics</h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400">
                Detailed analytics on your game performance
              </p>
            </div>
          </Link>

          <Link to="/courses/new" className="group">
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-indigo-500 hover:bg-gray-50 dark:hover:bg-gray-700/50">
              <div className="flex items-center mb-4">
                <div className="bg-indigo-100 dark:bg-indigo-900 p-3 rounded-lg">
                  <span className="text-2xl">➕</span>
                </div>
                <h3 className="text-xl font-semibold ml-4 text-gray-800 dark:text-gray-200">Add Course</h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400">
                Add a new golf course to the database
              </p>
            </div>
          </Link>

          <Link to="/rounds/new" className="group">
            <div className="bg-white dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border-l-4 border-red-500 hover:bg-gray-50 dark:hover:bg-gray-700/50">
              <div className="flex items-center mb-4">
                <div className="bg-red-100 dark:bg-red-900 p-3 rounded-lg">
                  <span className="text-2xl">🎯</span>
                </div>
                <h3 className="text-xl font-semibold ml-4 text-gray-800 dark:text-gray-200">New Round</h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400">
                Start tracking a new round of golf
              </p>
            </div>
          </Link>
        </div>

        <div className="mt-12 text-center">
          <div className="bg-white/95 dark:bg-gray-800/50 backdrop-blur rounded-xl shadow-lg p-8 max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">
              Welcome to Your Golf Companion
            </h2>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
              Track your rounds, analyze your performance, and discover new courses. 
              Whether you're a weekend warrior or a scratch golfer, our app helps you 
              improve your game with detailed statistics and GPS-enabled course management.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
